var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Multiselect',{attrs:{"label":"label","value":_vm.selected,"options":_vm.options,"searchable":false,"show-labels":false,"disabled":!_vm.canRefine},on:{"input":_vm.onChange}})}
var staticRenderFns = []

export { render, staticRenderFns }